export const TABLET_PORTRAIT = 768;
export const TABLET_LANDSCAPE = 1024;
